import { useNavigate } from 'react-router-dom';

/**
 * Branded 404 — launch gate (NAVIO-LAUNCH-READINESS Core Area 5): a friendly,
 * branded not-found screen with a clear way home + support, instead of a silent
 * redirect. (App crashes / 500s are caught by the Sentry ErrorBoundary in main.tsx.)
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
      <div className="space-y-1">
        <p className="text-sm font-medium text-muted-foreground">NavioFit</p>
        <h1 className="text-3xl font-semibold tracking-tight">Page not found</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          The page you're looking for doesn't exist or may have moved.
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate('/vessel/overview')}
          className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Go to Projects
        </button>
        <a
          href="mailto:support@naviomaritime.com?subject=NavioFit%20support"
          className="inline-flex h-10 items-center justify-center rounded-md border border-input px-4 text-sm font-medium hover:bg-muted"
        >
          Contact support
        </a>
      </div>
    </div>
  );
}
